import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { formatAddressToSummary } from "../../helpers/addressHelpers";
import { formatDate } from "../../helpers/dateHelpers";
import { formatShipmentStatus } from "./../../helpers/shipmentStatusHelpers";
import { formatVehicle } from "../../helpers/vehicleHelpers";
import PanelHeaderSummary from "./../Layout/Panel/PanelHeaderSummary";
import PanelHeaderSummaryInfo from "./../Layout/Panel/PanelHeaderSummaryInfo";

export default class Summary extends PureComponent {
  static propTypes = {
    load: PropTypes.object.isRequired,
    selectedBillOfLading: PropTypes.object.isRequired,
    userMetadata: PropTypes.object.isRequired
  };

  handleRoutingButton = () => {};

  render() {
    const { selectedBillOfLading, load, userMetadata } = this.props;
    const { soldTo = {}, careOf = {}, ultimateConsignee = {}, millOfOrigin = {}, invoices = {} } = selectedBillOfLading;
    const invoiceId = _.get(invoices, "customerInvoiceId", "");
    const invoiceType = _.get(invoices, "customerInvoiceType", "");
    const invoice = `${invoiceId || ""} ${invoiceType || ""}`;

    return (
      <PanelHeaderSummary>
        <div className="panel-summary__section-row">
          <PanelHeaderSummaryInfo className="--flex-3" label={i18n.t("billsOfLading.shippedFrom")} value={millOfOrigin.locationName} />
          <PanelHeaderSummaryInfo
            className="--flex-3"
            label={i18n.t("billsOfLading.careOf")}
            value={careOf.locationName}
            tooltipContent={i18n.t("tooltip.co")}
          />
          <PanelHeaderSummaryInfo className="--flex-2" label={i18n.t("billsOfLading.modeOfTransport")} value={selectedBillOfLading.modeOfTransport} />
          <PanelHeaderSummaryInfo
            className="--flex-2"
            label={i18n.t("billsOfLading.shippedDate")}
            value={formatDate(selectedBillOfLading.shippedDate, userMetadata.dateDisplayFormat)}
          />
        </div>
        <div className="panel-summary__section-row">
          <PanelHeaderSummaryInfo
            label={i18n.t("billsOfLading.soldTo")}
            customValue={formatAddressToSummary(soldTo.customerAddress, soldTo.customerName)}
            className="--flex-3"
          />
          <PanelHeaderSummaryInfo
            label={i18n.t("billsOfLading.ultimateConsignee")}
            customValue={formatAddressToSummary(ultimateConsignee.customerAddress, ultimateConsignee.customerName)}
            className="--flex-3"
          />
          <div className="panel-header__section-column --space-between">
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.carrier")} value={selectedBillOfLading.carrierName} />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.vehicle")} value={formatVehicle(selectedBillOfLading)} />
          </div>
          <div className="panel-header__section-column --space-between">
            <PanelHeaderSummaryInfo
              label={i18n.t("billsOfLading.shipmentStatus")}
              value={formatShipmentStatus(load.loadShipmentStatus, userMetadata.dateDisplayFormat)}
            />
            <PanelHeaderSummaryInfo label={i18n.t("billsOfLading.invoice")} value={invoice} />
          </div>
        </div>
      </PanelHeaderSummary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Summary.js